import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { SftpImportConfigurationWorkflow, ImportType, InventoryMode } from '../../../store/Models/Api/SftpImportModels';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { ProductIdentificationSection } from '../sections/ProductIdentificationSection';
import { FileStructureSection } from '../sections/FileStructureSection';
import { AdvancedOptionsSection } from '../sections/AdvancedOptionsSection';

interface BomDefaultHandlingPanelLocalProps {
    config: SftpImportConfigurationWorkflow;
}

type BomDefaultHandlingPanelProps = BomDefaultHandlingPanelLocalProps & ToxnotComponentProperties;

class BomDefaultHandlingPanelComponent extends ToxnotComponent<BomDefaultHandlingPanelProps> {
    render() {
        const { config } = this.props;
        const isSupplierImport = config.importType === ImportType.Suppliers;
        const isSingleImport = config.inventoryMode === InventoryMode.One && !isSupplierImport;

        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">{this.localizeString("Default Handling")}</h3>
                </div>
                <div className="panel-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <div className="row">
                        <div className="col-md-6">
                            {isSingleImport && (
                                <ProductIdentificationSection
                                    configData={config}
                                    onConfigChange={() => {}} // Read-only mode
                                    readOnly={true}
                                    showValidation={false}
                                />
                            )}

                            <div className="start-subcontent-heading">{this.localizeString("File Structure")}</div>
                            <FileStructureSection
                                configData={config}
                                onConfigChange={() => {}} // Read-only mode
                                readOnly={true}
                            />
                        </div>
                        {!isSupplierImport && (
                            <div className="col-md-6">
                                <AdvancedOptionsSection
                                    configData={config}
                                    onConfigChange={() => {}} // Read-only mode
                                    readOnly={true}
                                    collapsible={false}
                                    defaultExpanded={true}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export const BomDefaultHandlingPanel = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(BomDefaultHandlingPanelComponent);
